<template>
  <section class="p4 honor section">
    <div class="section-header">{{ $t('HomeText.p4_title') }}</div>
    <div class="section-content">
      <div class="main">
        <div class="box">
          <div class="image-wrapper">
            <img src="../../assets/images/home/p4-honor-1.png" alt=""/>
            <div class="add-on">
              <img src="../../assets/images/home/p4-honor-1-2.png" alt=""/>
            </div>
          </div>
          <div class="box-c">
            <div>
              {{ $t('HomeText.p4_1') }}
            </div>
            <div>
              {{ $t('HomeText.p4_1_2') }}
            </div>
          </div>
        </div>
        <div class="box">
          <div class="image-wrapper">
            <img src="../../assets/images/home/p4-honor-2.png" alt=""/>
            <div class="add-on">
              <img src="../../assets/images/home/p4-honor-2-2.png" alt=""/>
            </div>
          </div>
          <div class="box-c">
            {{ $t('HomeText.p4_2') }}
          </div>
        </div>
        <div class="box">
          <div class="image-wrapper">
            <img src="../../assets/images/home/p4-honor-3.png" alt=""/>
            <div class="add-on">
              <img src="../../assets/images/home/p4-honor-3-2.png" alt=""/>
            </div>
          </div>
          <div class="box-c">
            {{ $t('HomeText.p4_3') }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "p4-honor",
    data() {
      return {}
    },
  }
</script>


<style scoped lang="scss">
  .en .p4.honor {
    .section-content {
      .main {
        .box {
          .box-c {
            font-size: .9vw;
          }
        }
      }
    }
  }
</style>

<style scoped lang="scss">
  .p4.honor {
    padding-bottom: 2vw;

    .section-header {
      text-align: center;
      padding: 4vw 0;
      font-weight: bold;
      font-size: 3vw;
    }

    .section-content {
      .main {
        display: flex;
        justify-content: space-between;
        padding: 0 12vw;

        .box {
          width: calc(22vw + 2px);
          border: 1px solid transparent;
          cursor: pointer;
          background-color: #ffffff;

          &:hover {
            border-color: #1bb89d;
          }

          .image-wrapper {
            width: 22vw;
            height: 20vw;
            background-color: #f1f1f1;
            position: relative;

            .add-on {
              position: absolute;
              left: 0;
              bottom: -3vw;
              width: 100%;
              text-align: center;

              img {
                width: 6vw;
                height: 6vw;
              }
            }
          }

          .box-c {
            text-align: center;
            font-weight: bold;
            padding: 5vw 0 3vw 0;
            font-size: 1vw;
            line-height: 1vw;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/home/p4-honor.vue